<template>
  <div class="fireworksArtwork">
    <canvas class="fireworksArtwork__canvas" ref="canvas"></canvas>
  </div>
</template>

<script>
export default {
  data() {
    return {
      artwork: null
    }
  },
  mounted() {
    this.artwork = new this.$artworkFirework({
      canvas: this.$refs.canvas
    })
    this.$eventbus.$on('fireworksArtwork.shootFirework', this.shoot)
  },
  beforeDestroy() {
    this.$eventbus.$off('fireworksArtwork.shootFirework', this.shoot)
    this.artwork.destroy()
    this.artwork = null
  },
  methods: {
    shoot() {
      this.artwork.shoot()
    }
  }
}
</script>

<style lang="scss" scoped>
.fireworksArtwork {
  &__canvas {
    width: 100%;
    height: 100%;
    z-index: 10;
  }
}
</style>
